export default "__VITE_PUBLIC_ASSET__57fb7dd8__"